<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <form data-vv-scope="Examen" @submit.prevent="Examen_validate">
      <vx-card ref="filterCard" :title="$t('exam')" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
            <p class="mb-2">{{ $t('room') }} <b style="color: #ff6141">*</b></p>
            <v-select
              :disabled="true"
              :options="salles"
              @search="getSalle"
              :clearable="false"
              label="libelle"
              v-model="salle_input"
              class="w-full"
            />
          </div>
          <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
            <p class="mb-2" > Matière <b style="color: #ff6141">*</b></p>
            <v-select
              :disabled="true"
              :options="classeMatieres"
              @search="getClasseMatiere" 
              :clearable="true" 
              :getOptionLabel="getOptionLabel"
              v-model="classeMatiere"
              class="w-full"/>                
          </div>
          <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
            <p> {{ $t('exam_type') }} <b style="color: #ff6141">*</b> </p>
            <v-select
              :disabled="true"
              :reduce="rep => rep.id"
              :options="typeExamens"
              @search="getTypeExamen"
              :clearable="true"
              label="libelle"
              v-model="input.typeExamen"
              class="w-full" name="typeExamen" v-validate="'required'"/>
            <span class="text-danger">{{ errors.first('Examen.typeExamen') }}</span>
          </div>
          <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
            <p> {{ $t('partition') }}</p>
            <v-select
              :disabled="true"
              :reduce="rep => rep.id"
              :options="partitions"
              @search="getPartition"
              :clearable="true"
              label="long_label"
              v-model="input.partition"
              class="w-full" name="partition" v-validate="'required'"/>
            <span class="text-danger">{{ errors.first('Examen.partition') }}</span>
          </div>

          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full mb-2">
            <p> {{ $t('valuation_date') }} <b style="color: #ff6141">*</b> </p>
            <datepicker 
              :disabled="true" v-model="input.dateEvaluation" name="dateEvaluation" v-validate="'required'" ></datepicker>
            <span class="text-danger">{{ errors.first('Examen.dateEvaluation') }}</span>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full mb-2">
            <p> {{ $t('start_time') }} <b style="color: #ff6141">*</b> </p>
            <flat-pickr 
              :disabled="true" :config="configdateTimePicker" v-model="input.heureDebut" class="w-full" name="heureDebut" v-validate="'required'" />
            <span class="text-danger">{{ errors.first('Examen.heureDebut') }}</span>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full mb-2">
            <p> {{ $t('end_time') }} <b style="color: #ff6141">*</b> </p>
            <flat-pickr 
              :disabled="true" :config="configdateTimePicker" v-model="input.heureFin" class="w-full" name="heureFin" v-validate="'required'" />
            <span class="text-danger">{{ errors.first('Examen.heureFin') }}</span>
          </div>

        </div>
      </vx-card>

      <vx-card>
        <div slot="no-body" class="tabs-container px-6 pt-6">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-button radius color="primary" type="gradient" class="mr-4 mb-4">. {{ notess.length }} .</vs-button>
          </div>

          <table width="100%">
            <thead>
              <tr>
                <th> N° </th>
                <th>{{ $t("Registration_number") }}</th>
                <th>{{ $t("full_name") }}</th>
                <th>{{ $t("notes") }}</th>
              </tr>
            </thead>

            <tbody>
              <tr :key="indextr" v-for="(tr, indextr) in notess">
                <td>
                  <p class="product-name font-medium truncate">{{ indextr + 1 }}</p>
                </td>
                <td>
                  <p class="product-name font-medium truncate">{{ tr.inscription.eleve.matricule }}</p>
                </td>
                <td>
                  <p class="product-name font-medium truncate">{{ tr.inscription.eleve.full_name }}</p>
                </td>
                <td>
                  <vs-input
                    v-model="tr.valeur"
                    class="w-full"
                    v-validate="{ required: true, decimal: true, max_value: 20, min_value: 0 }"
                    :name="'valeur' + indextr" />
                  <span class="text-danger text-sm">{{ errors.first('Examen.valeur' + indextr) }}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <vs-button :disabled="!notess.length" class="mt-4 mb-4" color="success" type="border" icon-pack="feather" icon="icon-save" @click="Examen_validate">{{ $t("Submit") }}</vs-button>

          ..
        </div>
      </vx-card>
    </form>
  </div>
</template>

<script>
let base_self = ''
const input_tempon = {
  id: null,
  libelle: '',
  typeExamen: '',
  partition: '',
  professeurClasseMatiere: '',
  notess: [
    /*
      valeur: '',
      inscription: ''
    */
  ],
  dateEvaluation: '',
  heureDebut: '',
  heureFin: ''
}

import { Validator } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'

export default {
  components: { flatPickr, Datepicker },
  data () {
    return {
      classeMatiere: '',
      classeMatieres: [],
      salles: [],
      salle_input: '',
      paramClasseMatiere: {
        is_get: true,
        paginate: {
          length: 30,
          page: 1
        },
        filter: {
          q_list: [],
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          anneeScolaire__id: this.$store.state.anneeScolaire.id
        },
        juste: {
          id: '',
          classe: {
            id: '',
            libelle: '',
            niveau: {
              id: ''
            }
          },
          matiere: {
            libelle: ''
          }
        }
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      noteObject: {},
      notess: [],
      label: ['eleve', 'full_name'],
      paramProfesseurClasseMatiere: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: [],
          salle__is_active: true,
          salle__classe__is_active: true,
          salle__classe__niveau__is_active: true,
          salle__classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          classeMatiere__anneeScolaire__id: this.$store.state.anneeScolaire.id
        }
      },
      paramTypeExamen: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      paramInscription: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: []
        },
        orderby: ['eleve__full_name'],
        exclude: { }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true
        },
        orderby: ['ordre']
      },
      professeurClasseMatieres: [],
      professeurClasseMatieres1: [],
      inscriptions: [],
      partitions: [],
      partitions1: [],
      typeExamens: [],
      input1: JSON.parse(JSON.stringify(input_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    salle_input (value) {
      if (value) {
        // base_self.param.filter['professeurClasseMatiere__salle__id'] = value.id
        base_self.paramClasseMatiere.filter['classe__id'] = value.classe.id
        base_self.paramClasseMatiere.filter['anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        base_self.paramClasseMatiere.filter['classe__niveau__niveauTypePartitions__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id

        base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        base_self.paramPartition.filter['niveauTypePartition__niveau__id'] = value.classe.niveau.id
      } else {
        // delete base_self.param.filter['professeurClasseMatiere__salle__id']
        delete base_self.paramClasseMatiere.filter['classe__id']
        delete base_self.paramClasseMatiere.filter['anneeScolaire__id']
        delete base_self.paramClasseMatiere.filter['classe__niveau__niveauTypePartitions__anneeScolaire__id']

        delete base_self.paramPartition.filter['niveauTypePartition__anneeScolaire__id']
        delete base_self.paramPartition.filter['niveauTypePartition__niveau__id']
      }

      base_self.getPartitionSimple()
      base_self.getClasseMatiereSimple()
      // base_self.getExamens()
    },
    input: {
      handler  () {
        let call = true

        if (base_self.input1.professeurClasseMatiere !== base_self.input.professeurClasseMatiere) {
          if (!base_self.input.professeurClasseMatiere || base_self.input.professeurClasseMatiere === '') {
            delete base_self.paramInscription.filter['anneeScolaire__id']
            delete base_self.paramInscription.filter['professeurClasseMatiere__id']
            base_self.partitions = []
          } else {
            base_self.paramInscription.filter['anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
            base_self.paramInscription.filter['salle__professeurClasseMatieres__id'] = base_self.input.professeurClasseMatiere
          }
        }

        // Control approfondis
        if (base_self.input1.professeurClasseMatiere && base_self.input.professeurClasseMatiere && base_self.input1.partition && base_self.input.partition && base_self.input1.partition === base_self.input.partition && base_self.input1.professeurClasseMatiere.id === base_self.input.professeurClasseMatiere.id) {
          call = false
        }
        // Control approfondis

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
        if (call) base_self.getInscriptionSimple()
      },
      deep: true
    }
  },
  methods: {
    getOptionLabel (option) {
      if (typeof option === 'object') {

        return `${option.matiere.libelle}`
      }
      return option
    },
    getClasseMatiereSimple () {
      delete base_self.paramClasseMatiere.filter['matiere__libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ClasseMatiere`, base_self.paramClasseMatiere)
        .then((response) => {
          base_self.classeMatieres = JSON.parse(JSON.stringify(response.data.data))

          console.log('response: ', response)
          console.log('base_self.paramClasseMatiere: ', base_self.paramClasseMatiere)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getClasseMatiere (search, loading) {
      loading(true)
      base_self.paramClasseMatiere.filter['matiere__libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ClasseMatiere`, base_self.paramClasseMatiere)
        .then((response) => {
          base_self.classeMatieres = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__classeMatieres__isnull: false
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        },
        orderby: ['classe__ordre', 'ordre'],
        exclude: { code: 'Attente' }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__classeMatieres__isnull: false,
          libelle__icontains: search
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        },
        orderby: ['classe__ordre', 'ordre'],
        exclude: { code: 'Attente' }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          base_self.salles = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getTypeExamenSimple () {
      delete base_self.paramTypeExamen.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeExamen`, base_self.paramTypeExamen)
        .then((response) => {
          base_self.typeExamens = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getTypeExamen (search, loading) {
      loading(true)
      base_self.paramTypeExamen.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}TypeExamen`, base_self.paramTypeExamen)
        .then((response) => {
          base_self.typeExamens = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getPartitionSimple () {
      delete base_self.paramPartition.filter['long_label__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.initInputPartition(response.data.data)
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))
          base_self.partitions.push(...base_self.partitions1)

          // console.log('base_self.partitions: ', base_self.partitions)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    initInputPartition (partitions) {
      if (partitions.length === 1) {
        base_self.input.partition = partitions[0].id
      }
    },
    getPartition (search, loading) {
      loading(true)
      base_self.paramPartition.filter['long_label__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Partition`, base_self.paramPartition)
        .then((response) => {
          base_self.initInputPartition(response.data.data)
          base_self.partitions = JSON.parse(JSON.stringify(response.data.data))
          base_self.partitions.push(...base_self.partitions1)
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    async initialisationForNotes (inscriptions) {
      const dict = {
        custom: {
          professeurClasseMatiere: {
            required: base_self.$t('The_matter_by_teachers_is_required')
          },
          valeur: {
            required: 'Le champ valeur3 doit être numérique et peut contenir des points décimaux'
          },
          typeExamen: {
            required: base_self.$t('The_type_examen_is_required')
          },
          partition: {
            required: base_self.$t('The_partition_is_required')
          },
          dateEvaluation: {
            required: base_self.$t('The_valuation_date_is_required')
          },
          heureDebut: {
            required: base_self.$t('The_start_time_is_required')
          },
          heureFin: {
            required: base_self.$t('The_end_time_is_required')
          }
        }
      }

      // console.log('base_self.noteObject: ', base_self.noteObject)

      const length = inscriptions.length
      const notess = []
      for (let i = 0; i < length; i++) {
        if (base_self.noteObject[inscriptions[i].id]) {
          notess.push(base_self.noteObject[inscriptions[i].id])
        } else {
          // console.log(' Je suis entrer. ')
          notess.push({
            valeur: '',
            inscription: inscriptions[i]
          })
        }

        dict.custom[`valeur${i}`] = {
          required: base_self.$t('This_filed_is_required'),
          decimal: base_self.$t('This_field_must_be_numeric_and_may_contain_decimal_points'),
          max_value: base_self.$t('This_field_must_be_20_or_less'),
          min_value: base_self.$t('This_field_must_be_0_or_more')
        }
      }

      // console.log('notess: ', notess)

      base_self.notess = JSON.parse(JSON.stringify(notess))
      Validator.localize('en', dict)
    },
    getDispenserDUneMatiere () {
      return new Promise((resolve) => {
        const param = JSON.parse(JSON.stringify(base_self.$store.state.paramDispenserDUneMatiere))
        param.filter['partition__id'] = base_self.input.partition
        param.filter['professeurClasseMatiere__id'] = base_self.input.professeurClasseMatiere
        param.filter['is_active'] = true

        base_self.$http.post(`${base_self.$store.state.route_for_esm}DispenserDUneMatiere`, param)
          .then((response) => {
            const length  = response.data.data.length
            const id__in = []
            for (let i = 0; i < length; i++) {
              const item = response.data.data[i]
              id__in.push(item.inscription.id)
            }
            resolve(id__in)
          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
          })
      })
    },
    async getPartitionInscriptions () {
      if (base_self.input.salle && base_self.input.salle.id && base_self.input.partition && base_self.input.partition.id) {
        base_self.$vs.loading()
        
        base_self.param.filter['inscription__anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        base_self.param.filter['inscription__salle__id'] = base_self.input.salle.id
        base_self.param.filter['partition__id'] = base_self.input.partition.id

        base_self.$http.post(`${base_self.$store.state.route_for_esm}PartitionInscription`, base_self.param)
          .then((response) => {
            base_self.partitionInscriptions = response.data.data
            base_self.taille = response.data.taille

            base_self.$vs.loading.close()
          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
            base_self.$vs.loading.close()
          })
      }
    },
    async getInscriptionSimple () {
      if (base_self.input.professeurClasseMatiere && base_self.input.partition) {
        const id__in = await base_self.getDispenserDUneMatiere()

        base_self.paramInscription.filter['anneeScolaire__id'] = base_self.$store.state.anneeScolaire.id
        base_self.paramInscription.filter['salle__professeurClasseMatieres__id'] = base_self.input.professeurClasseMatiere
        base_self.paramInscription.filter['partitionInscriptions__partition__id'] = base_self.input.partition
        base_self.paramInscription.filter['partitionInscriptions__state'] = true
        base_self.paramInscription.filter['partitionInscriptions__is_active'] = true

        if (id__in.length) {
          // console.log('id__in: ', id__in)
          base_self.paramInscription.exclude = { id__in }
        }

        base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
          .then((response) => {
            // console.log('response.data.data Inscription : ', response.data.data)
            base_self.initialisationForNotes(response.data.data)
          })
          .catch((error) => {
            console.log('error: ', error)
          })
      }
    },
    getProfesseurClasseMatiereSimple () {
      delete base_self.paramProfesseurClasseMatiere.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ProfesseurClasseMatiere`, base_self.paramProfesseurClasseMatiere)
        .then((response) => {
          base_self.professeurClasseMatieres = JSON.parse(JSON.stringify(response.data.data))
          base_self.professeurClasseMatieres.push(...base_self.professeurClasseMatieres1)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getProfesseurClasseMatiere (search, loading) {
      loading(true)
      base_self.paramProfesseurClasseMatiere.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ProfesseurClasseMatiere`, base_self.paramProfesseurClasseMatiere)
        .then((response) => {
          base_self.professeurClasseMatieres = JSON.parse(JSON.stringify(response.data.data))
          base_self.professeurClasseMatieres.push(...base_self.professeurClasseMatieres1)
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    Examen_validate () {
      base_self.$validator.validateAll('Examen').then(result => {
        if (result) {
          base_self.submitData()
        }
      })
    },
    initializePage () {
      // base_self.$router.push('/report_cards_management/Exam/0').catch(() => {})
      base_self.$router.push('/report_cards_management/exam/').catch(() => {})
    },
    async submitData () {
      base_self.$vs.loading()
      const input = JSON.parse(JSON.stringify(base_self.input))
      const notess__ = JSON.parse(JSON.stringify(base_self.notess))

      const length = notess__.length
      for (let i = 0; i < length; i++) {
        input.notess.push({
          id: notess__[i].id ? notess__[i].id : null,
          valeur: Number(notess__[i].valeur),
          inscription: notess__[i].inscription.id
        })
      }

      console.log('input: ', input)

      if (!input.id) {
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Examen`, input)
          .then((response) => {
            window.getESM.success(base_self.$t('The_Exam_is_added_successfully'), response)
            base_self.$vs.loading.close()
            base_self.initializePage()
            // base_self.setMultipleBulletin(response, 'The_Exam_is_added_successfully')
          })
          .catch((error) => {
            base_self.$vs.loading.close()
            console.log('error: ', error)
          })
      } else if (input.id) {
        input.nonEffectuer = false
        base_self.$http.put(`${base_self.$store.state.route_for_esm}Examen`, input)
          .then((response) => {
            window.getESM.success(base_self.$t('The_Exam_is_changed_successfully'), response)
            base_self.$vs.loading.close()
            base_self.initializePage()
            // base_self.setMultipleBulletin(response, 'The_Exam_is_changed_successfully')
          })
          .catch((error) => {
            base_self.$vs.loading.close()
            console.log('error: ', error)
          })
      }
    },
    // set-multiple-bulletin
    setMultipleBulletin (repss, libelle) {
      /* const input = {
        id_partition: repss.data.data.partition.id,
        id_salle: repss.data.data.professeurClasseMatiere.salle.id
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}set-multiple-bulletin`, input)
        .then((response) => {
          console.log('response: ', response)
      }   */
      base_self.$http.post(`${base_self.$store.state.route_for_esm}set-multiple-bulletin/${repss.data.data.partition.id}/${repss.data.data.professeurClasseMatiere.salle.id}/0`)
        .then(() => {
          base_self.$vs.loading.close()
        })
        .catch((error) => {
          base_self.$vs.loading.close()
          console.log('error: ', error)
        })
      window.getESM.success(base_self.$t(libelle), repss)
      base_self.$router.push('/report_cards_management/exam/').catch(() => {})
    },
    initValues () {
      /* base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon)) */

      base_self.$validator.errors.clear()
    },
    getNotes (examen_id) {
      return new Promise((resolve) => {
        const param = JSON.parse(JSON.stringify(base_self.$store.state.paramNotes))
        param.filter['examen__id'] = examen_id
        param.filter['examen__state'] = true
        param.orderby = ['inscription__eleve__full_name']

        // console.log('param: ', param)
        

        base_self.$http.post(`${base_self.$store.state.route_for_esm}Notes`, param)
          .then((response) => {
            const length  = response.data.data.length
            // console.log('length: ', length)
            const object = {}

            for (let i = 0; i < length; i++) {
              object[response.data.data[i].inscription.id] = response.data.data[i]
            }

            const param = JSON.parse(JSON.stringify(base_self.$store.state.paramExamen))
            param.filter['id'] = examen_id

            base_self.$http.post(`${base_self.$store.state.route_for_esm}Examen`, param)
              .then((response) => {
                const item = response.data.data[0]

                base_self.professeurClasseMatieres1 = [item.professeurClasseMatiere]
                base_self.partitions1 = [item.partition]

                const input = {
                  id: examen_id,
                  libelle: item.libelle,
                  typeExamen: item.typeExamen.id,
                  partition: item.partition.id,
                  professeurClasseMatiere: item.professeurClasseMatiere.id,
                  notess: [],
                  dateEvaluation: item.dateEvaluation,
                  heureDebut: item.heureDebut,
                  heureFin: item.heureFin
                }

                base_self.classeMatiere = item.professeurClasseMatiere.classeMatiere
                base_self.salle_input = item.professeurClasseMatiere.salle
                
                base_self.input = input

                resolve(object)
              })
              .catch(() => {
                window.getESM.error(base_self.$t('The_server_is_not_responding'))
                base_self.$vs.loading.close()
              })

          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
          })
      })
    }
  },
  async created () {
    base_self = this

    const id = Number(base_self.$route.params.id)
    if (id !== 0) {
      base_self.$vs.loading()
      base_self.noteObject = await base_self.getNotes(id)
      base_self.$vs.loading.close()
    }

    base_self.initValues()
    base_self.getProfesseurClasseMatiereSimple()
    base_self.getTypeExamenSimple()
    base_self.getSalleSimple()

    ///////////////////////////
    const dict = {
      custom: {
        professeurClasseMatiere: {
          required: base_self.$t('The_matter_by_teachers_is_required')
        },
        inscription: {
          required: base_self.$t('The_Student_is_required')
        },
        typeExamen: {
          required: base_self.$t('The_type_examen_is_required')
        },
        partition: {
          required: base_self.$t('The_partition_is_required')
        },
        dateEvaluation: {
          required: base_self.$t('The_valuation_date_is_required')
        },
        heureDebut: {
          required: base_self.$t('The_start_time_is_required')
        },
        heureFin: {
          required: base_self.$t('The_end_time_is_required')
        }
      }
    }
    Validator.localize('en', dict)
    //////////////////////////
  }
}

</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .flatpickr-input, [dir] .flatpickr-input[type="hidden"] + input {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
